import React, { useState } from 'react';
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { PageContainer, TabListFp } from 'components';
import { RequestStepOne, RequestCompleteDetailStepTwo, CheckRegistration } from '../components';
import { useEffect } from 'react';
import { useStyles } from './style';
import Services from '../services/Services';
import { MessageBlockDg } from '../components';
import axios from 'axios';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
const RequestWarranty = () => {
  // -- STATES --//
  const [isLoaloding, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('1');
  const [warrantyList, setWarrantyList] = useState([]);
  const [typeWarranty, setTypeWarranty] = useState(null);
  const [isError, setIsError] = useState(true);
  const [price, setPrice] = useState(null);
  const [lastData, setLastData] = useState(null);
  const [isEnable, setIsEnable] = useState(true);
  const [isLoadingSelectRadio, setIsLoadingSelectRadio] = useState(false);
  const [bockDg, setBlockDg] = useState({
    isOpen: false,
    warranty: null,
    title: '',
    phoneNumber: '',
  })
  const actionsList =
    getDynamicObjectAction([
      'requestWarrantyPage',

    ]);
  const [radioList, setRadioList] = useState([]);
  const [selectedRadioWarrantyType, setSelectedRadioWarrantyType] = useState('');
  const [isErrorRadioWarrantyService, setIsErrorRadioWarrantyService] = useState(false); // اگه سرویس پرایس تیبل به خطا بخوره این فیلد ترو میشود و استپ یک محتواش نشون داده نمیشود
  // -- HOOKS --//
  const classes = useStyles();
  useEffect(() => {
    if (actionsList['requestWarrantyPage']) getData();
    else setIsLoading(false);

  }, []);

  /**
   * دریافت لیست ضمانت‌نامه های درخواست شده توسط کاربر
   * دریافت لیست قراردادها - فعلا فقط یک مورد داریم و سیستم توسط همین یه مورد پیاده سازی شده است
   * دریافت شماره تماس کاربر لاگین شده 
   */
  const getData = async () => {
    try {
      const params = {};
      const requests = await Services.getRequestOne({ warrantyStatuses: ['WAITING', 'INCOMPLETE', 'ERROR'] });
      //const requests = { result: [] };
      if (requests?.result?.length) { // اگه سرویس ریکوعست داده داشته باشه سپس پرایس تیبل و چک کردن ها انجام میشه و در صورت وجود شرایط به یک تب منتقل خواهد شد
        //setSelectedRadioWarrantyType(requests?.result[0]?.source['warranty-type']);
        const warrantyList = await Services.getWarranyList(requests?.result[0]?.source['warranty-type']);
        createStringWarranty(requests?.result[0]?.source['warranty-type'], warrantyList)
        setWarrantyList(warrantyList?.result);

        await getDataRadioButton()
        checkStep(requests?.result, warrantyList?.result);
      } else { // اگه سرویس ریکوعست داده ای برنگرده و خالی باشه

        await getDataRadioButton()
      }
      setIsLoading(false);
      setIsError(false);
    } catch (error) {

      setIsLoading(false);
      setIsError(true);
    }
  };
  const onNextTab = (tab) => {
    setActiveTab(tab);
  };

  /**
   * در زمان ورود کاربر به این صفحه ، بررسی میشود آیا کاربر درخواست در صف دارد یا خیر - 
   * آخرین رکورد برگشتی رو دریافت میکنه و براساس وضعیت و شروط زیر عملیات به تب های مختلف و نمایش پیغام انجام میشود
   */
  const checkStep = (result = [], wList) => {
    if (!result.length || result == [] || !result) {
      setActiveTab('1');
      return;
    }
    if (result[0].source['is-closed'] == true) {
      setActiveTab('1');
      return;
    } else {
      //result[0].source['warranty-step'] = 'REGISTER_INQUIRY';
      //result[0].source['warranty-status'] = 'REJECTED'
      let warrntyStep = result[0]?.source['warranty-step'];
      const warrantyItem = result[0];
      const wType = result[0]?.source['warranty-type'];
      //let warrntyStep = 'EDIT_INFO';
      // INFO("ثبت درخواست"),//0
      //   EDIT_INFO("اصلاح اطلاعات"),//0
      //   REGISTER_INQUIRY("استعلام مدرک"), // 1
      //   REGISTER_CHEQUE("ثبت چک"), // 2
      //   REGISTER_CONTRACT("ایجاد قرارداد"), // 3
      //   SIGNATURE_CONTRACT("وضعیت امضا قرارداد"), // 4
      //   FILING("تشکیل پرونده"); //5
      //========================================================
      // INFO("ثبت درخواست"),//0
      // EDIT_INFO("اصلاح اطلاعات"),//0
      // REGISTER_INQUIRY("استعلام مدرک"), // 1
      // REGISTER_COLLATERAL("ثبت وثیقه"), // 2
      // COLLATERAL_INQUIRY("استعلام وثیقه"), // 2
      // REGISTER_CONTRACT("ایجاد قرارداد"), // 3
      // SIGNATURE_CONTRACT("وضعیت امضا قرارداد"), // 4
      // FILING("تشکیل پرونده"); //5
      //=========================================================
      switch (warrntyStep) {
        case 'INFO':
          setActiveTab('1');
          break;

        case 'EDIT_INFO':
          setSelectedRadioWarrantyType(wType);
          setActiveTab('2');
          setPrice(wList['amount-limit']);
          setLastData(warrantyItem);
          break;

        case 'REGISTER_INQUIRY':
          setSelectedRadioWarrantyType(wType);
          setActiveTab('2');
          setIsEnable(false);
          setBlockDg({ isOpen: true, title: 'تکمیل اطلاعات', warranty: warrantyItem })
          setLastData(warrantyItem);
          break;

        case 'REGISTER_COLLATERAL':
          setSelectedRadioWarrantyType(wType);
          setActiveTab('3');
          setLastData(warrantyItem);
          break;

        case 'COLLATERAL_INQUIRY':
          setSelectedRadioWarrantyType(wType);
          setActiveTab('3');
          setIsEnable(false);
          setBlockDg({ isOpen: true, title: 'ثبت وثیقه', warranty: warrantyItem })
          setLastData(warrantyItem);
          break;

        case 'REGISTERED':
          setActiveTab('1');
          break;


        default: {
          if (wList?.type === 'PARTICIPATION_TENDERS') {
            setSelectedRadioWarrantyType(wType);
            setActiveTab('3');
            setIsEnable(false);
            setBlockDg({ isOpen: true, title: 'ثبت وثیقه', warranty: warrantyItem })
          } else { // صد نقد
            setSelectedRadioWarrantyType(wType);
            setActiveTab('2');
            setIsEnable(false);
            setBlockDg({ isOpen: true, title: 'تکمیل اطلاعات', warranty: warrantyItem })
          }
          setLastData(warrantyItem);
          break;
        }
      }

    }
  }

  /**
 * سرویس دریافت رادیو باتن ها در تب اول
 */
  const getDataRadioButton = async () => {
    await Services.getWarrantiesDetailsRadioButton().then(res => {
      setRadioList(res?.result);
    }).catch(error => {
    })
  }


  /**
   * هر کدام از رادیو باتن ها در تب اول انتخاب شود این تابع کال میشود
   */
  const onSelectWarranty = async (warrantyType) => {
    setTypeWarranty(null)
    setPrice(null);
    setWarrantyList(null);
    try {
      setIsLoadingSelectRadio(true);
      const warrantyList = await Services.getWarranyList(warrantyType);
      createStringWarranty(warrantyType, warrantyList)
      setWarrantyList(warrantyList?.result);
      setIsLoadingSelectRadio(false);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setIsLoadingSelectRadio(false);
        setIsErrorRadioWarrantyService(true)
      }
    }

  }
  /**
   * باکس نوع ضمانت نامه در تب اول را میسازد - دو جا استفاده شده واسه همین تابع شد
   */
  const createStringWarranty = (warrantyType, warrantyList) => {
    if (warrantyType === 'PARTICIPATION_TENDERS') {
      warrantyList.result['cash-deposit-percentage'] =
        warrantyList.result['cash-deposit-percentage'] + ' درصد مبلغ ضمانت‌نامه '; // سپرده
      warrantyList.result['commission-percentage'] =
        warrantyList.result['commission-percentage'] + ' درصد مبلغ ضمانت‌نامه سالیانه '; // کارمزد
      warrantyList.result[
        'collateral-percentage'
      ] = `چک شرکت به میزان ${warrantyList.result['collateral-percentage']} درصد ضمانت‌نامه`; // وثیقه
    }

  }

  const hint = 'کاربر گرامی، جهت صدور ضمانت‌نامه مراحل زیر را تکمیل کنید.';

  return (
    <PageContainer
      title="درخواست صدور"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.WARRANTY_REQUEST}
      loading={isLoaloding}
    >
      {actionsList['requestWarrantyPage'] && (
        <>

          {
            !isError && (
              <TabContext value={activeTab}>
                <TabListFp
                  //onChange={(e, v) => setActiveTab(v)}
                  variant="scrollable" scrollButtons="auto">
                  <Tab disableRipple={true} label="نوع ضمانت‌نامه" value="1" />
                  <Tab disableRipple={true} label="تکمیل اطلاعات" value="2" />
                  <Tab disableRipple={true} label="ثبت وثیقه" value="3"
                    style={selectedRadioWarrantyType !== 'PARTICIPATION_TENDERS' ? { visibility: 'hidden', display: 'none' } : {}} />
                </TabListFp>

                <TabPanel value="1" className={classes.tabPanel}>
                  <RequestStepOne
                    warrantyList={[warrantyList]}
                    typeWarranty={typeWarranty}
                    setTypeWarranty={setTypeWarranty}
                    onNextTab={onNextTab}
                    setPrice={setPrice}
                    radioList={radioList}
                    selectedRadioWarrantyType={selectedRadioWarrantyType}
                    setSelectedRadioWarrantyType={setSelectedRadioWarrantyType}
                    onSelectWarranty={onSelectWarranty}
                    isLoadingSelectRadio={isLoadingSelectRadio}
                    isErrorRadioWarrantyService={isErrorRadioWarrantyService}
                  />
                </TabPanel>
                <TabPanel value="2" className={classes.tabPanel}>
                  {/* <ShebasList /> */}
                  <RequestCompleteDetailStepTwo
                    isEnable={isEnable}
                    lastData={lastData}
                    price={price}
                    typeWarranty={typeWarranty}


                  />
                </TabPanel>
                <TabPanel value="3" className={classes.tabPanel}>
                  <CheckRegistration isEnable={isEnable} lastData={lastData} />
                </TabPanel>
              </TabContext>
            )
          }

          <MessageBlockDg condition={bockDg} />
        </>

      )}

    </PageContainer>
  );
};

export default RequestWarranty;


